import { createAction } from '@reduxjs/toolkit'

export const fetchCampaigns = createAction('campaign/fetchCampaigns')
export const updateCampaign = createAction('campaign/updateCampaign')
export const createCampaign = createAction('campaign/createCampaign')
export const deleteCampaign = createAction('campaign/deleteCampaign')
